import type { RouteLocationRaw } from 'vue-router';

export interface SubHeaderBreadcrumb { callback?: () => void; route?: RouteLocationRaw; label?: string }

/**
 * Global state for the sub header (breadcrumbs etc)
 */
export default function useSubHeaderState() {
    const breadcrumbs = useState<SubHeaderBreadcrumb[]>('sub_header_breadbrumbs', () => []);

    return {
        breadcrumbs,
    };
}
